import React, { useContext, useState } from "react";
import { TextField, Button, Box, Typography, Alert } from "@mui/material";
import AuthContext from "../auth/AuthContext";

const Register = () => {
  const { register } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [regUsername, setRegUsername] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regConfirmPassword, setRegConfirmPassword] = useState("");
  const [invitationCode, setInvitationCode] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (regPassword !== regConfirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (regPassword.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    try {
      await register(regUsername, regEmail, regPassword, invitationCode);
      setSuccess("Registration successful! Please log in with your new account.");
      setRegUsername("");
      setRegEmail("");
      setRegPassword("");
      setRegConfirmPassword("");
      setInvitationCode("");
    } catch (err) {
      setError(err.response?.data?.detail || "Registration failed");
    }
  };

  return (
    <Box sx={{ width: 400, margin: "0 auto", padding: 2 }}>
      <Typography variant="h4" gutterBottom align="center">
        Agritur
      </Typography>
      <Typography variant="h5" gutterBottom align="center">
        Register
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          {success}
        </Alert>
      )}

      <form onSubmit={handleRegister}>
        <TextField
          fullWidth
          label="Username"
          value={regUsername}
          onChange={(e) => setRegUsername(e.target.value)}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Email"
          type="email"
          value={regEmail}
          onChange={(e) => setRegEmail(e.target.value)}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          value={regPassword}
          onChange={(e) => setRegPassword(e.target.value)}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Confirm Password"
          type="password"
          value={regConfirmPassword}
          onChange={(e) => setRegConfirmPassword(e.target.value)}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Invitation Code"
          value={invitationCode}
          onChange={(e) => setInvitationCode(e.target.value)}
          margin="normal"
          required
          helperText="Enter the invitation code you received"
        />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
          Register
        </Button>
      </form>
    </Box>
  );
};

export default Register;


